import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { ErrorDialog } from '../../ui/dialog/error/error.dialog';
import { GetProfileUseCase, UserInterface } from '../../../core';
import { Loader } from '../../client/helpers/loader';
import { MatDialog } from '@angular/material/dialog';

import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './view.page.html',
    styleUrls: ['./view.page.scss'],
})
export class ViewPage implements OnInit {
    public user: UserInterface;
    public showBack = false;
    public back: Subject<boolean> = new Subject();
    public isClientPortal = environment.portalClient;

    constructor(private dialog: MatDialog, private getProfileUseCase: GetProfileUseCase, public loader: Loader) {}

    ngOnInit() {
        this.getProfile();
    }

    private getProfile() {
        this.getProfileUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.user = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    showBackButton() {
        this.showBack = true;
    }

    hideBackButton() {
        this.showBack = false;
    }

    onBack() {
        this.back.next(true);
    }
}
